import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { ChevronComponent } from '@shared/chevron/chevron.component';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';
import { PainPointsAndSolutionItem } from '@content/home/pain-points-and-solutions/pain-points-and-solutions.type';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-pain-points-and-solutions',
    imports: [
        ContentWrapperComponent,
        NgOptimizedImage,
        AssetPipe,
        ChevronComponent,
        JoinClassNamesPipe,
        NgClass,
        RouterLink,
    ],
    templateUrl: './pain-points-and-solutions.component.html',
    styleUrl: './pain-points-and-solutions.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PainPointsAndSolutionsComponent {
    public contentItems: PainPointsAndSolutionItem[] = [
        {
            imgPath: 'chat-delete',
            title: $localize`:@@pain-point-title-disorganized:Disorganized Processes`,
            subtitle: $localize`:@@pain-point-subtitle-disorganized:Lack of organization in business processes can lead to inefficiencies and confusion`,
            solution: $localize`:@@pain-point-solution-disorganized:Implement task and project management features to help users organize and prioritize their workflows`,
        },
        {
            imgPath: 'time-share',
            title: $localize`:@@pain-point-title-lack:Lack of Real-time Visibility`,
            subtitle: $localize`:@@pain-point-subtitle-lack:Businesses may struggle to access real-time information about their operations, which can impede decision-making`,
            solution: $localize`:@@pain-point-solution-lack:Our app can provide real-time reporting and analytics to give users immediate insights into their business performance`,
        },
        {
            imgPath: 'finance',
            title: $localize`:@@pain-point-title-financial:Financial Management Challenges`,
            subtitle: $localize`:@@pain-point-subtitle-financial:Many businesses find it challenging to manage their finances, including invoicing, expense tracking, and financial reporting`,
            solution: $localize`:@@pain-point-solution-financial:Integrate accounting features to simplify financial management, generate invoices, track expenses, and provide detailed financial reports`,
        },
        {
            imgPath: 'flow-chart',
            title: $localize`:@@pain-point-title-task:Task and Project Management Complexity`,
            subtitle: $localize`:@@pain-point-subtitle-task:Keeping track of tasks and projects can be complex, leading to missed deadlines and confusion`,
            solution: $localize`:@@pain-point-solution-task:Task and project management tools in our app can help users stay organized, set priorities, and meet deadlines`,
        },
        {
            imgPath: 'search-home',
            title: $localize`:@@pain-point-title-inefficient:Inefficient Resource Allocation`,
            subtitle: $localize`:@@pain-point-subtitle-inefficient:Businesses may struggle to allocate resources, including employee time and inventory, efficiently`,
            solution: $localize`:@@pain-point-solution-inefficient:Implement features that help businesses allocate resources effectively, such as employee time tracking and inventory management`,
        },
        {
            imgPath: 'flag',
            title: $localize`:@@pain-point-title-missed:Missed Deadlines and Milestones`,
            subtitle: $localize`:@@pain-point-subtitle-missed:Missing deadlines and milestones can impact business success and client satisfaction`,
            solution: $localize`:@@pain-point-solution-missed:Implement a notification system to alert users to upcoming deadlines and milestone achievements`,
        },
        {
            imgPath: 'database',
            title: $localize`:@@pain-point-title-data:Data-Driven Decision-Making`,
            subtitle: $localize`:@@pain-point-subtitle-data:Many businesses struggle to make informed decisions due to a lack of data insights`,
            solution: $localize`:@@pain-point-solution-data:Provide data analytics and reporting features to enable data-driven decision-making`,
        },
    ];

    public toggle(item: PainPointsAndSolutionItem): void {
        item.isShown = !item.isShown;
    }
}
